import { gql } from "@apollo/client";

export interface LCFeedDay {
	milestoneId: number
	feedcurveId: number
	day: number
	nDay: number
	compCnt: number
	feedcurve_day_components: LCFeedcurveDayComponent[]
}

export interface LCFeedcurveDayComponent {
	componentId: number
	amount: number
}


export const LC_FEED_DAY = gql`
query GetLcFeedDay($domain: String!, $lanControllerId: Int!) {
	controller {
		lcFeedDay(domain: $domain, lanControllerId: $lanControllerId) {
			milestoneId
			feedcurveId
			day
			nDay
			compCnt
			feedcurve_day_components {
				componentId
				amount
			}
		}
	}
}
`

export interface LCFeedDayResponse {
	controller: {
		lcFeedDay: LCFeedDay[] | null
	}
}

export interface LCFeedDayArgs {
	domain: string;
	lanControllerId: number;
}

